import { toFloatBigNumber } from '@/util/big'
import { formatEther, parseEther } from 'ethers/lib/utils'

export const useFormatRswEth = () => formatEther
export const useParseRswEth = () => parseEther
export const useToRswEthFloat = () => toFloatBigNumber
